import { render } from "./Record.vue?vue&type=template&id=510380e0&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=510380e0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510380e0"]])

export default __exports__